import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import social1Png from '~/assets/images/anatomy/social1.png'
import social1Webp from '~/assets/images/anatomy/social1.webp'
import social2Png from '~/assets/images/anatomy/social2.png'
import social2Webp from '~/assets/images/anatomy/social2.webp'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { selectIsLegalComplianceCountry } from '~/shared/store/user/selects'
import { TPageProps } from '~/shared/types/commonTypes'

import RatingsAnatomyWorldMap from './RatingsAnatomyWorldMap'
import { Styles as S } from './styles'

const RatingsAnatomy = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Join 1,500,000+ learners worldwide',
  })
  const isLegalComplianceCountry = useSelector(selectIsLegalComplianceCountry)

  if (isLegalComplianceCountry) {
    return (
      <S.Root>
        <RatingsAnatomyWorldMap onContinue={() => handleContinue('')} />
      </S.Root>
    )
  }

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Card>
          <S.Title>
            <Trans ns="anatomy" i18nKey="onboarding.ratingsAnatomy.title" />
          </S.Title>

          <S.ReviewCard>
            <S.ReviewText>
              <Trans
                ns="anatomy"
                i18nKey="onboarding.ratingsAnatomy.reviewText"
              />
            </S.ReviewText>

            <S.ReviewSource>
              <Trans
                ns="anatomy"
                i18nKey="onboarding.ratingsAnatomy.reviewSource"
              />
            </S.ReviewSource>
          </S.ReviewCard>

          <S.FeaturedSection>
            <S.FeaturedLabel>
              <Trans
                ns="anatomy"
                i18nKey="onboarding.ratingsAnatomy.asFeaturedin"
              />
            </S.FeaturedLabel>

            <picture>
              <source srcSet={social1Webp} type="image/webp" />
              <S.SocialImage1 src={social1Png} alt="As featured in" />
            </picture>

            <picture>
              <source srcSet={social2Webp} type="image/webp" />
              <S.SocialImage2 src={social2Png} alt="As featured in" />
            </picture>
          </S.FeaturedSection>
        </S.Card>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default RatingsAnatomy
